<script setup lang="ts">
defineProps({ blok: Object })
</script>

<template>
    <section
        :class="[
            'story__blok story__blok--column-text',
            {
                'bg-chsc-raw': blok?.background,
            },
        ]"
    >
        <UiContainer
            :max-width="blok?.container_width"
            :class="{ 'px-9': blok?.container_width == 'max-w-full' }"
        >
            <div class="grid grid-cols-2 gap-x-12 max-[769px]:grid-cols-1 max-[769px]:gap-y-10 max-[769px]:gap-x-0">
                <div>
                    <StoryblokRichText :doc="blok?.text1" />
                </div>
                <div :class="{ '-order-1': blok?.reversed }">
                    <StoryblokRichText :doc="blok?.text2" />
                </div>
            </div>
        </UiContainer>
    </section>
</template>
